var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 512 512",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M448 107h-85V64q0-27-18.5-45.5T299 0h-86q-27 0-45.5 18.5T149 64v43H64q-27 0-45.5 18T0 171v277q0 27 18.5 45.5T64 512h384q27 0 45.5-18.5T512 448V171q0-28-18.5-46T448 107zM192 64q0-21 21-21h86q21 0 21 21v43H192V64zM64 469q-21 0-21-21V171q0-22 21-22h21v320H64zm64 0V149h256v320H128zm341-21q0 21-21 21h-21V149h21q21 0 21 22v277z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.84d5ace989f64a01a59e16831c40fcb3.svg";
export { ForwardRef as ReactComponent };